module.exports = __webpack_public_path__ + "media/images/user/favicons/OGP-e2453c2b608c3f800a688b143303edbb.png";